export default "__VITE_ASSET__b9b636e7__"